import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import DOMPurify from 'dompurify'; // Import DOMPurify untuk sanitasi data
import he from 'he';
import './AllPost.css';

 // Fungsi untuk mendecode entitas HTML
 const decodeHtml = (html) => {
  return he.decode(html); // Menggunakan pustaka he untuk mendecode
};

const AllPost = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    // Memastikan halaman tidak dimuat dalam iframe
    if (window.self !== window.top) {
      window.top.location = window.self.location;
    }
    
    axios
      .get(`https://infoupiyptk.com/webupiyptk/api/post/all-post.php?limit=9&page=${page}`)
      .then((response) => {
        // Pastikan data yang diterima aman dari XSS dengan DOMPurify
        const sanitizedPosts = response.data.posts.map(post => ({
          ...post,
          title: decodeHtml(DOMPurify.sanitize(post.title)),
          excerpt: decodeHtml(DOMPurify.sanitize(post.excerpt)),
        }));
        
        setPosts(sanitizedPosts);
        setTotalPages(response.data.totalPages);
        setLoading(false);
        setError(null);
      })
      .catch((error) => {
        setError('Failed to load posts');
        setLoading(false);
      });

  }, [page]);

  const truncateText = (text, length = 100) => {
    if (text.length > length) {
      return text.substring(0, length) + '...';
    }
    return text;
  };

  const formatDate = (dateString) => {
    const options = { day: '2-digit', month: 'long', year: 'numeric' };
    const date = new Date(dateString);
    return date.toLocaleDateString('id-ID', options);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }


  return (
    <div className="all-posts">
      <Container>
        <Row>
          {posts.map((post) => (
            <Col md={4} key={post.id} className="mb-4">
              <div className="post-card">
                <div>
                 
                    {/* /* Gunakan HTTPS untuk keamanan */}
                    <img
                      src={post.featured_image ? `https://infoupiyptk.com/webupiyptk/api/post/uploads/${post.featured_image}` : 'sample-post-image.jpg'}
                      onError={(e) => { e.target.src = 'https://infoupiyptk.com/webupiyptk/api/post/uploads/sample-post-image.jpg'; e.target.onerror = null; }} // Fallback jika gambar gagal dimuat
                      alt={post.title}
                      className="post-image"
                    />      

                  <div className="post-date">{formatDate(post.created_at)}</div>
                  <h2 className="post-title-all">
                    {truncateText(post.title, 70)}
                  </h2>
                  <p className="post-excerpt">
                    {truncateText(post.excerpt, 100)}
                  </p>
                </div>

                <div>
                  {/* Gunakan <Link /> dengan sanitasi URL untuk menghindari manipulasi */}
                  <Link to={`/post/${encodeURIComponent(post.url)}`} className="read-more-button">
                    Selengkapnya
                  </Link>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Pagination Controls */}
      <div className="pagination">
        <button
          onClick={() => setPage(page > 1 ? page - 1 : 1)}
          disabled={page === 1}
        >
          Previous
        </button>
        <span>Page {page} of {totalPages}</span>
        <button
          onClick={() => setPage(page < totalPages ? page + 1 : totalPages)}
          disabled={page === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default AllPost;
